import { RadioGroup } from "@wix/design-system";
import React, { useContext, useState } from "react";
import { RicosContext } from "./../../../ricos-context";
import { LinkInput } from "./../../../ui-components";
import {
  EDIT_PANEL_RADIO_GROUP,
  EDIT_PANEL_RADIO_HTML,
  EDIT_PANEL_RADIO_URL,
  EDIT_PANEL_URL_INPUT
} from "../../dataHooks";
import { HtmlInputArea } from "./HtmlInputArea";
const INPUT_HTML = "html";
const INPUT_URL = "url";
const HtmlSourceInput = ({
  componentData,
  updateComponentData,
  inputRef
}) => {
  const { t } = useContext(RicosContext);
  const [inputType, setInputType] = useState(componentData.url ? INPUT_URL : INPUT_HTML);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    RadioGroup,
    {
      display: "vertical",
      value: inputType,
      onChange: (value) => setInputType(value),
      dataHook: EDIT_PANEL_RADIO_GROUP,
      size: "small"
    },
    /* @__PURE__ */ React.createElement(RadioGroup.Radio, { value: INPUT_HTML, dataHook: EDIT_PANEL_RADIO_HTML }, t("HtmlEditPanel_Code")),
    /* @__PURE__ */ React.createElement(RadioGroup.Radio, { value: INPUT_URL, dataHook: EDIT_PANEL_RADIO_URL }, t("HtmlEditPanel_Source"))
  ), inputType === INPUT_HTML ? /* @__PURE__ */ React.createElement(
    HtmlInputArea,
    {
      placeholder: t("HtmlEditPanel_HtmlInput_Placeholder"),
      componentData,
      onChange: updateComponentData
    }
  ) : /* @__PURE__ */ React.createElement(
    LinkInput,
    {
      value: componentData.url ?? "",
      placeholder: t("HtmlEditPanel_UrlInput_Placeholder"),
      dataHook: EDIT_PANEL_URL_INPUT,
      inputRef,
      onChange: (url) => {
        updateComponentData({ ...componentData, url, html: void 0 });
      }
    }
  ));
};
export {
  HtmlSourceInput
};
//# sourceMappingURL=HtmlSourceInput.js.map
